'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = undefined;

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = require('vue-i18n');

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _zh = require('./zh');

var _zh2 = _interopRequireDefault(_zh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);
_vue2.default.locale = function () {};
var i18n = exports.i18n = new _vueI18n2.default({
  locale: 'zh_CN',
  messages: _zh2.default
});